import { map } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';

import { ContextActions } from '../actions/context.actions';
import { ResellerActions } from '../actions/reseller.actions';
import { selectSelectedReseller } from '../selectors/reseller.selectors';

@Injectable()
export class ResellerEffects {
  actions$ = inject(Actions);
  store = inject(Store);

  loadResellers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContextActions.loadSuccess),
      map((action) => {
        return ResellerActions.loadResellersSuccess({
          resellers: action.initialAppContext.resellers,
          resellerContextSwitchable:
            action.initialAppContext.resellerContextSwitchable,
        });
      }),
    );
  });

  resellersLoaded$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ResellerActions.loadResellersSuccess),
      concatLatestFrom(() => this.store.select(selectSelectedReseller)),
      map(([action, selectedReseller]) => {
        if (selectedReseller === null && action.resellers.length > 0) {
          return ResellerActions.selectReseller({
            reseller: action.resellers[0],
            clearClientSelection: false,
          });
        } else if (selectedReseller !== null) {
          const currentlySelected = action.resellers.find(
            (r) => r.id === selectedReseller.id,
          );
          return ResellerActions.selectReseller({
            reseller: currentlySelected ?? null,
            clearClientSelection: false,
          });
        } else {
          return ResellerActions.selectReseller({
            reseller: null,
            clearClientSelection: false,
          });
        }
      }),
    );
  });
}
